import React from 'react';
import s from './GridTableHead.module.css';
import { useTranslation } from 'react-i18next';

type Props = {
    columns: string[];
    hiddenOnMobileIndexes?: number[]; // 0-based indexes to hide on mobile
    gridTemplateColumns?: string; // Custom grid template columns
    customClassName?: string; // Custom CSS class for the table row
};

const GridTableHead: React.FC<Props> = ({ 
    columns, 
    hiddenOnMobileIndexes = [],
    gridTemplateColumns,
    customClassName
}) => {
    const { t } = useTranslation();
    
    const renderColumnElement = (text: string, index: number) => (
        <div
            className={`${s.tableColumn} ${hiddenOnMobileIndexes.includes(index) ? s.hideOnMobile : ''}`}
            key={text + index}
        >
            {t(text)}
        </div>
    );
    
    // Если передан customClassName, используем его вместе с базовым s.tableRow для обеспечения display: grid
    // Инлайн стиль gridTemplateColumns переопределит любые CSS классы
    const className = customClassName ? `${s.tableRow} ${customClassName}` : s.tableRow;
    
    return (
        <div 
            className={className}
            style={gridTemplateColumns ? { gridTemplateColumns } : undefined}
        >
            {columns.map(renderColumnElement)}
        </div>
    );
};

export default GridTableHead;
